module.exports = __webpack_public_path__ + "255425dd7196ffe48aab028b8f81bc66.woff2";